$(document).ready(function () {
  $('#generalSearch').on('input', function () {
    var query = $(this).val();

    if (query.length < 5) {
      $('#searchResults').empty().hide();
      return;
    }

    $.ajax({
      url: "/autocomplete",
      method: 'GET',
      data: { query: query },
      success: function (data) {
        displayResults(data, query);
      }
    });
  });
});

function displayResults(results, searchTerm) {
  $('#searchResults').empty();

  var cleanSearchTerm = searchTerm.replace(/d\//gi, '').replace(/f\//gi, '').replace(/o\//gi, '');
  var searchTerms = cleanSearchTerm.split(/\s+/).filter(term => term.trim().length > 1);

  searchTerms = [...new Set(searchTerms)];

  results.forEach(function (item) {
    var resultItem = $('<div class="result-item"></div>');
    var itemName = item.name;

    if (itemName.toLowerCase().includes("cliente nuevo")) {
      resultItem.html('<span>' + itemName + '</span>');
    } else {
      var highlightedItemName = highlightText(itemName, searchTerms);
      resultItem.html(highlightedItemName);
    }

    resultItem.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      function openInNewTab(url) {
        window.open(url, '_blank', 'noopener');
      }
      if (item.id === null && item.url) {
        openInNewTab(item.url);
      } else if (item.id !== null) {
        var customerId = item.id;
        if (item.is_admin == 1) {
          openInNewTab("/administradores/editar/" + customerId);
        } else if (item.type == 'job') {
          let jobId = item.id;
          openInNewTab("/trabajos/editar/" + jobId);
        } else {
          openInNewTab("/clientes/editar/" + customerId);
        }
      }
      return false;
    });

    $('#searchResults').append(resultItem);
  });

  var searchInputPosition = $('#generalSearch').position();
  $('#searchResults').css({
    top: searchInputPosition.top + $('#generalSearch').outerHeight(),
    left: searchInputPosition.left,
    width: $('#generalSearch').outerWidth()
  }).show();
}

function highlightText(text, terms) {
  terms.forEach(function(term) {
      var regex = new RegExp(`\\b(${escapeRegExp(term)})\\b`, 'gi');
      text = text.replace(regex, '<span style="background-color: yellow;">$1</span>');
  });
  return text;
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
